import { axios, getConfigs, IRequestConfig, IRequestOptions } from './api'
import {
  AcquisitionProtocolDto,
  CreateAcquisitionPoroctolDto,
  FindAcquisitionProtocolsQuery,
  UpdateAcquisitionProtocolDto,
} from './dtos/AcquisitionProtocolDto'
import { PaginatedDto } from './extendedType'

export class AcquisitionProtocolsService {
  private static basePath = process.env.REACT_APP_API_URL

  static findAll(
    query?: FindAcquisitionProtocolsQuery,
  ): Promise<PaginatedDto<AcquisitionProtocolDto>> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + '/acquisition-protocols'

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        {},
      )
      configs.params = query
      const data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static create(
    dto?: CreateAcquisitionPoroctolDto,
  ): Promise<AcquisitionProtocolDto> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + '/acquisition-protocols'
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static update(
    id: number,
    dto: UpdateAcquisitionProtocolDto,
  ): Promise<AcquisitionProtocolDto> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + `/acquisition-protocols/${id}`
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static remove(id: Number): Promise<void> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + `/acquisition-protocols/${id}`
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        {},
      )
      const data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Batch import multistep protocols via CSV
   */
  static batchMultiStepProtocolImport(
    params: {
      siteId: number
      file: File
    } = {} as any,
    options: IRequestOptions = {},
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + '/exam/protocols/batch-import'

      const configs: IRequestConfig = getConfigs(
        'post',
        'multipart/form-data',
        url,
        options,
      )

      const formData = new FormData()
      formData.append('file', params.file)
      formData.append('siteId', params.siteId.toString())

      configs.data = formData
      axios(configs, resolve, reject)
    })
  }
}
